export function cpicker(ctx) {
    return {
        styles: {
            main: { bg_color: ctx.SCR, bg_opa: 255, scale_width: 15, pad_inner: 10, radius: 999 },
            // indicator = cpicker_indic
            indicator: { border_width: 2, border_color: '#808080' },
            // knob = cpicker_indic also in fw (same part reused)
            knob: { border_width: 2, border_color: '#9a9a9a' },
        },
    };
}
